import { fetchFilteredMovies } from "@multicines/services";
import { Movie, Store, Vendor } from "@multicines/types";

/**
 * Fetches the selected movie based on the provided parameters.
 * @param externalStoreId - The external ID of the store.
 * @param selectedMovieId - The external ID of the selected movie.
 * @param modality - The modality of the movie.
 * @param vendorId - The ID of the vendor.
 * @returns The selected movie object, or undefined if not found.
 */
export const fetchSelectedMovie = async (
  externalStoreId: Store["additionalInfo"]["externalId"],
  selectedMovieId: Movie["externalId"],
  modality: Movie["modality"],
  vendorId: Vendor["id"]
) => {
  const movies = await fetchFilteredMovies(
    externalStoreId!,
    modality!,
    vendorId!
  );
  const [movie] =
    movies?.filter(movie => movie.externalId === selectedMovieId) ?? [];
  return movie;
};
